module.exports = ".display-block {\r\n    display:block;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rx/view/popup/popup.css
// module id = ./node_modules/@rx/view/popup/popup.css
// module chunks = vendor